(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/services/services.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/services/services.js');
'use strict';

var _svs$tickets$data$mod, _svs$tickets$data$mod2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ServiceButtons = svs.tickets.next.components.services.ServiceButtons;
const ServiceLinks = svs.tickets.next.components.services.ServiceLinks;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const rawServiceMenuItems = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.serviceMenuItems) || ((_svs$tickets$data$mod2 = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod2 === void 0 ? void 0 : _svs$tickets$data$mod2.menu) || [];
const serviceMenuItems = rawServiceMenuItems.map(item => _objectSpread(_objectSpread({}, item), {}, {
  title: item.title || item.name || '',
  subTitle: item.subTitle || '',
  url: item.url || item.anchor || ''
})).filter(item => item.active !== false);
const Services = () => {
  const buttons = serviceMenuItems.filter(item => item.featured);
  const links = serviceMenuItems.filter(item => !item.featured);
  return React.createElement("div", {
    className: "tickets-next-grid-lock w100 padding-h-1"
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    am: {
      gutter: 0
    },
    lg: {
      gutter: 0
    },
    md: {
      gutter: 0
    },
    sm: {
      gutter: 0
    },
    xl: {
      gutter: 0
    },
    xs: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    am: {
      col: 8,
      offset: 2
    },
    lg: {
      col: 6,
      offset: 3
    },
    md: {
      col: 6,
      offset: 3
    },
    sm: {
      col: 10,
      offset: 1
    },
    xl: {
      col: 6,
      offset: 3
    },
    xs: {
      col: 12,
      offset: 0
    }
  }, React.createElement(ServiceButtons, {
    services: buttons
  }))), React.createElement(GridRow, {
    am: {
      gutter: 0
    },
    lg: {
      gutter: 0
    },
    md: {
      gutter: 0
    },
    sm: {
      gutter: 0
    },
    xl: {
      gutter: 0
    },
    xs: {
      gutter: 0
    }
  }, React.createElement(GridCol, {
    am: {
      col: 8,
      offset: 2
    },
    lg: {
      col: 6,
      offset: 3
    },
    md: {
      col: 6,
      offset: 3
    },
    sm: {
      col: 10,
      offset: 1
    },
    xl: {
      col: 6,
      offset: 3
    },
    xs: {
      col: 12,
      offset: 0
    }
  }, React.createElement(ServiceLinks, {
    services: links
  })))));
};
setGlobal('svs.tickets.next.components.services.Services', Services);

 })(window);